export default __webpack_public_path__ + "static/4-698568514f162863c9e4eb6b913168e4.png";